export const scaleHandler = {
    register: () => {},
};
